import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { StarryBackground } from "./StarryBackground";
import "./NotFound.css";

export const NotFound: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [ripples, setRipples] = useState<{
    [key: string]: { x: number; y: number; timestamp: number } | null;
  }>({
    back: null,
  });

  // Check theme from document attribute
  useEffect(() => {
    const checkTheme = () => {
      const theme = document.documentElement.getAttribute("data-theme");
      setIsDarkMode(theme !== "light");
    };

    checkTheme();

    // Watch for theme changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const handleButtonClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    buttonKey: string
  ) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRipples((prev) => ({
      ...prev,
      [buttonKey]: { x, y, timestamp: Date.now() },
    }));

    // Clear ripple after animation
    setTimeout(() => {
      setRipples((prev) => ({
        ...prev,
        [buttonKey]: null,
      }));
    }, 600);
  };

  return (
    <div className="not-found-page">
      <StarryBackground isDarkMode={isDarkMode} />

      <div className="not-found-container">
        <div className="not-found-content">
          <img
            src={
              isDarkMode ? "/polytrome_logo.svg" : "/polytrome_logo_black.svg"
            }
            alt="Polytrome"
            className="not-found-logo"
          />

          <div className="not-found-main-content">
            <div className="not-found-number">404</div>
            <div className="not-found-beat-dots">
              <div className="beat-dot"></div>
              <div className="beat-dot"></div>
              <div className="beat-dot"></div>
              <div className="beat-dot"></div>
            </div>
            <h1 className="not-found-title">Not Found</h1>
            <p className="not-found-description">
              The page you are looking for does not exist.
            </p>
          </div>

          <div className="back-button-container">
            <Link
              to="/"
              className="back-button"
              onClick={(e) => handleButtonClick(e as any, "back")}
            >
              {ripples.back && (
                <span
                  className="button-ripple"
                  style={{
                    left: ripples.back.x,
                    top: ripples.back.y,
                  }}
                />
              )}
              {FaArrowLeft({})}
              Back to Polytrome
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
